const wrapper = props => props.children;

export default wrapper;



// WEBPACK FOOTER //
// ./src/hoc/Wrapper/Wrapper.js